import React, { useState, useEffect, useRef } from 'react';
import moment from 'moment-timezone';
import { useFormContext } from 'react-hook-form';
import { fetchOptions } from '../queries';
import Select from '../select/Select';

function useFirstRender() {
    const ref = useRef(true);
    const firstRender = ref.current;
    ref.current = false;
    return firstRender;
}

const RouteSession = ({ name, query, props, user, intervalRef }) => {
    const [selectProps, setSelectProps] = useState({ ...props, options: [] });
    const [lockOptions, setLockOptions] = useState(false);
    const [loading, setLoading] = useState(true);
    const isFirstRender = useFirstRender();
    const {
        watch,
        setError,
        clearErrors,
        getValues,
        // wrap
    } = useFormContext();
    const { endpoint, where = {}, order, populate, labelKey, roleConstraints, useLoopback } = query;
    const { intervalField, intervalFilterKey } = intervalRef || {};

    useEffect(
        () => {
            let whereClause = { ...where };
            // Limit route sessions to either the date selected or today
            const interval = getValues(intervalField);
            whereClause[intervalFilterKey] = { between: [moment(interval).subtract(24, 'hours'), moment(interval).add(24, 'hours')] };

            // If a default value exists, fetch the route session on the first render and lock it in
            const value = getValues(name);
            if (value && isFirstRender) {
                setLockOptions(true);
                setSelectProps((prev) => ({ ...prev, disabled: true }));
                whereClause = { _id: value };
            }

            const getOptions = async () => {
                setLoading(true);
                const optionsResponse = await fetchOptions({ endpoint, where: whereClause, order, populate, labelKey, roleConstraints, user, useLoopback });

                if (optionsResponse.error) {
                    setSelectProps((prev) => ({ ...prev, options: [] }));
                    setError(name, { type: 'fetch options', message: `Could not fetch ${props.label} options` });
                } else {
                    setSelectProps((prev) => ({ ...prev, options: optionsResponse }));
                    clearErrors([name]);
                }
                setLoading(false);
            };

            if (!lockOptions) {
                getOptions();
            }
        },
        !!intervalField ? [...watch([intervalField]), user] : [user]
    );

    // Form label for select options and selected display
    const formatLabel = (option, options) => {
        let labelOption = { ...option };
        if (typeof option === 'string') {
            labelOption = options?.find((opt) => (opt.id || opt._id) === option);
        }

        if (!labelOption || !Object.keys(labelOption).length) {
            return '';
        }
        const { created_by, route_id, BOL, created_at } = labelOption;
        return `Driver: ${created_by?.name} -- Route: ${route_id?.name} -- BOL: ${BOL} -- Date: ${moment(created_at).format('MMM DD, Y')}`;
    };

    return (
        <Select
            name={name}
            // labelKey="BOL"
            formatLabel={formatLabel}
            props={{ ...selectProps }}
            loading={loading}
            // wrap
        />
    );
};

export default RouteSession;
